// extracted by mini-css-extract-plugin
export var cancelButton = "_mi-5";
export var content = "_mi-3";
export var createButton = "_mi-6";
export var drawerContainer = "_mi-0";
export var footer = "_mi-2";
export var header = "_mi-1";
export var orderFormColumn = "_mi-4";